'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const CopyIcon = ({ sx, className }) => {
  return (
    <SvgIcon sx={sx} data-testid="CopyIcon">
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <g clipPath="url(#clip0_278_10537)">
          <path
            d="M0.703369 2.58287V1.36814C0.703369 0.976938 1.0205 0.659805 1.4117 0.659805H2.62643M0.703369 5.81852V8.18407M5.86209 0.659805H8.22762M11.4255 0.659805H12.5563C12.9475 0.659805 13.2647 0.976938 13.2647 1.36814V2.58287M0.703369 11.382V12.5127C0.703369 12.9039 1.0205 13.221 1.4117 13.221H2.62643"
            stroke={sx?.color || '#3D517B8F'}
            strokeWidth={sx?.strokeWidth || '0.708333'}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeOpacity={sx?.strokeOpacity || '0.56'}
          />
          <path
            d="M16.2973 15.6318C16.2973 16.023 15.9802 16.3401 15.5889 16.3401H5.15487C4.76367 16.3401 4.44653 16.023 4.44653 15.6318V5.1977C4.44653 4.8065 4.76367 4.48936 5.15487 4.48936H15.5889C15.9802 4.48936 16.2973 4.8065 16.2973 5.1977V15.6318Z"
            stroke={sx?.color || '#3D517B8F'}
            strokeWidth={sx?.strokeWidth || '0.708333'}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeOpacity={sx?.strokeOpacity || '0.56'}
          />
        </g>
      </svg>
    </SvgIcon>
  )
}

CopyIcon.propTypes = {
  sx: PropTypes.object,
  className: PropTypes.string
}
